import api from '../api';

const path = '/sell/commercial';
const pathPro = '/sell/pro/commercial';

export const addCommercialRequest = (values) => {
    api.post(`${path}/add`, values);
};
export const getCommercialRequest = (id) => api.get(`${path}/get/${id}`);
export const deleteCommercialRequest = (id) =>
    api.delete(`${path}/delete/${id}`);
export const getCommercialListRequest = (params) =>
    api.get(`${path}/get`, { params });
export const editCommercialRequest = (updates) =>
    api.put(`${path}/edit/${updates.id}`, {
        updates,
    });
export const updateCommercialRequest = (updates) =>
    api.put(`${pathPro}/edit/${updates.id}`, {
        updates,
    });

export const addCommercialProRequest = (values) =>
    api.post(`${pathPro}/add`, values);
export const editCommercialProRequest = (updates) =>
    api.put(`${pathPro}/edit/${updates.id}`, {
        updates,
    });
